import { Divider, MenuItem } from '@mui/material';

import { TrashIcon } from '@sanity/icons';
import { useAssortmentTFunction } from '@retail/monitoring-assortment/i18n';
import { AddIcon, PenIcon } from '@shared/custom-icons';
import { Menu, MenuButton } from '@retail/components';

interface Props {
  onEditNameClick: () => void;
  onAddClick: () => void;
  onDeleteClick: () => void;
}

export const EditAssortmentMenu: React.FC<Props> = ({
  onEditNameClick,
  onAddClick,
  onDeleteClick,
}) => {
  const t = useAssortmentTFunction();
  return (
    <Menu>
      {({ onClose }) => (
        <>
          <MenuButton color="secondary" size="small" sx={{ whiteSpace: 'nowrap' }}>
            {t('assortment.editAssortment')}
          </MenuButton>
          <MenuItem
            onClick={() => {
              onAddClick();
              onClose();
            }}
          >
            {t('assortment.addItems')}
            <AddIcon
              stroke="currentColor"
              sx={(theme) => ({
                color: 'primary.main',
                ...theme.applyStyles('dark', { color: 'primary.light' }),
              })}
            />
          </MenuItem>
          <MenuItem
            onClick={() => {
              onEditNameClick();
              onClose();
            }}
          >
            {t('assortment.admin.edit.options.editTitle')}
            <PenIcon fontSize="small" />
          </MenuItem>
          <Divider />
          <MenuItem
            color="warning"
            onClick={() => {
              onDeleteClick();
              onClose();
            }}
            sx={(theme) => ({
              '& svg': {
                color: 'common.black',
                ...theme.applyStyles('dark', { color: 'text.primary' }),
              },
            })}
          >
            {t('assortment.admin.edit.options.delete')}
            <TrashIcon fontSize="25px" />
          </MenuItem>
        </>
      )}
    </Menu>
  );
};
